import React, {Component} from 'react';

class Options extends Component{
	constructor(props){
		super(props);

		this.changeOption = this.changeOption.bind(this);

		this.state = {
			options : ""
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		if(this.props.match.path.replace('/', '') === 'fractioning'){
			this.setState({
				options: "Block"
			});
		}else{
			this.setState({
				options: "Unit"
			});
		}
		
	}

	changeOption(e){
		this.setState({
			options: e.target.value
		})

		this.props.sendData(e.target.value);
	}


	render(){
		return (
			<div className="col-xs-12" style={{padding:"0"}}>
				<span className="span-min">Seleccione</span>
				<select className="form-control" name="options" onKeyPress={(e) => this.props.validate(e)}
					onChange={this.changeOption} value={this.state.options || ""} autoFocus={true}>
					<option value="Unit">POR UNIDAD</option>
					<option value="Block">EN BLOQUE</option>
				</select>				
			</div>
		)
	}
}

export default Options;